import React from "react";
import AxiosConfig from "axiosConfig";
import CustomInput from "components/General/Form/CustomInput";
import TextTheme from "components/General/Text/TextTheme";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import CustomBanner from "components/General/Form/CustomBanner";

class ResendActivation extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: "",
			emailError: "",
			status: "",
		};
	}

	onDataChange = (event) => {
		this.setState({ [event.target.name]: event.target.value });
		this.validate(event);
	};

	validate = (event) => {
		function validateEmail(email) {
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		}
		this.setState({
			emailError: validateEmail(this.state.email)
				? ""
				: "Please enter a valid email address.",
		});
	};

	handleSubmit = (event) => {
		event.preventDefault();
		let form_data = new FormData();
		if (this.state.email === "") {
			this.setState({ emailError: "Email cannot be empty" });
		}
		if (
			this.state.email !== "" &&
			this.state.emailError === ""
		) {
			form_data.append("email", this.state.email);
			AxiosConfig.post("account/resend_activate/", form_data);
			this.setState({ status: "An email containing the activation link has been send to you." });
		}
	};

	render() {
		return (
			<div>
				<CustomBanner message="Resend Activation Link." />

				<div style={{ textAlign: "-webkit-center",}}>
					<form className="form_register">
					<h5 className="subtitle">
						<TextTheme
							message="Provide your email to resend the activation link."
							className="text_medium text_dark_blue"
						/>
					</h5>
						<CustomInput
							name="email"
							error={this.state.emailError}
							placeholder="Email"
							value={this.state.email}
							handleChange={this.onDataChange.bind(this)}
							handleBlur={this.validate.bind(this)}
						/>
						<div style={{ display: "flex" }}>
                            <div style={{ marginLeft: "auto" }}>
						<RoundedButton
							title="&nbsp;&nbsp;&nbsp;Submit&nbsp;&nbsp;&nbsp;"
							buttonClassName="background_dark_orange form_button"
							textThemeClassName="text_medium text_white"
							handleOnClick={this.handleSubmit}
						/>
							</div>
						</div>
						<br/>
						<TextTheme
							message={this.state.status}
							className="text_small text_red"
						/>
					</form>
				</div>
			</div>
		);
	}
}

export default ResendActivation;